import { Location } from '@angular/common';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { ScannedActionsSubject } from '@ngrx/store';
import { OAuthService } from 'angular-oauth2-oidc';
import { first, forkJoin, mergeMap, of } from 'rxjs';
import { AuthService } from '../../../services/auth/auth.service';
import { BackendFeatureService } from '../../../services/backend-feature.service';
import { BaseViewConfigService } from '../../../services/base-view-config/base-view-config.service';
import { LoginCheckService } from '../../../services/login-check.service';
import { LoginConfigService } from '../../../services/login-config/login-config.service';
import { NavbarConfigService } from '../../../services/navbar-config/navbar-config.service';
import { LoginComponent } from '../login.component';

@Component({
    selector: 'lib-fashion-login',
    templateUrl: './fashion-login.component.html',
    styleUrls: ['./fashion-login.component.css'],
    standalone: false
})
export class FashionLoginComponent extends LoginComponent implements OnInit {
  forgotPassword: boolean;
  requestAccountEnabled: boolean;
  view: string;
  public backgroundImage: string = this.navbarConfigService.getBackgroundLoginUrl();
  // public logoUrl: string = this.navbarConfigService.getLogoUrl();
  public logoUrl: string = this.navbarConfigService.getLogoLoginUrl();

  public videoBackground: string;
  public showLanguageDropDown: boolean;
  public showInTabsEnabled: boolean;

  public mfaState: 'setup' | 'code' | null = null;

  requestAccountComponent = this.baseViewConfigService.getRequestAccountComponent();

  constructor(
    protected authService: AuthService,
    protected formBuilder: FormBuilder,
    protected route: ActivatedRoute,
    protected router: Router,
    protected actions$: ScannedActionsSubject,
    protected location: Location,
    protected loginCheckService: LoginCheckService,
    protected loginConfigService: LoginConfigService,
    protected navbarConfigService: NavbarConfigService,
    protected baseViewConfigService: BaseViewConfigService,
    @Optional()
    protected oauth2Service: OAuthService,
    @Optional()
    @Inject('environment')
    protected environment: { [s: string]: any },
    protected backendFeatureService: BackendFeatureService
  ) {
    super(authService, formBuilder, route, router, actions$, loginCheckService, oauth2Service, backendFeatureService);
  }

  ngOnInit() {
    super.ngOnInit();

    this.authService.getMfaInfo().subscribe(mfa => {
      if (mfa.required) {
        this.mfaState = mfa.state;
        this.view = 'mfa-login';
        this.loginDone();
      }
    });

    this.forgotPassword = this.checkUrl(this.location.path());
    this.router.events.pipe(first()).subscribe((val: NavigationStart) => {
      this.forgotPassword = this.checkUrl(val.url || (val as any).routerEvent?.url);
    });

    this.requestAccountEnabled = this.loginConfigService.showRequestAccount();
    this.view = this.forgotPassword ? 'forgot-password' : 'login';
    this.videoBackground = this.loginConfigService.getVideoBackground();
    this.showLanguageDropDown = this.loginConfigService.getShowLanguageDropDown();
    this.showInTabsEnabled = this.loginConfigService.getShowInTabsEnabled();

    this.navbarConfigService
      .getBackgroundLoginUrlObservable()
      .pipe(
        first(),
        mergeMap(loginBackground =>
          forkJoin({
            loginBackground: of(loginBackground),
            logoLoginUrl: this.navbarConfigService.getLogoLoginUrlObservable().pipe(first())
          })
        )
      )
      .subscribe(({ loginBackground, logoLoginUrl }) => {
        if (loginBackground) {
          if (
            loginBackground.endsWith('.mp4') ||
            loginBackground.endsWith('.webm') ||
            loginBackground.endsWith('.ogg')
          ) {
            this.videoBackground = loginBackground;
            this.backgroundImage = null;
          } else if (!this.videoBackground) {
            this.backgroundImage = loginBackground;
            this.videoBackground = null;
          }
        }

        if (logoLoginUrl) {
          this.logoUrl = logoLoginUrl;
        }
      });
  }

  protected checkUrl = (url: string): boolean => {
    if (url && url === '/forgot-password') {
      return true;
    }
    return false;
  };

  public returnToLoginFn() {
    this.view = 'login';
  }

  tabChanged(event) {
    this.view = event.nextId;
  }
}
